import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '@/store'
import { DEFAULT_LANG } from '@/helpers/constant'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const currentLang = store.state.currentLang

  if (currentLang === DEFAULT_LANG) {
    next()
    return
  }
  if (to.query.lang !== currentLang) {
    next({
      path: to.path,
      query: { ...to.query, lang: currentLang },
      hash: to.hash,
      params: to.params
    })
  } else {
    next()
  }
})

export default router
